<template>
  <div class="skeleton-block" :style="blockStyle" />
</template>

<script>
export default {
  name: 'SkeletonBlock',
  props: {
    width: { type: [String, Number], default: '100%' },
    height: { type: [String, Number], default: '16px' },
    radius: { type: [String, Number], default: '4px' },
    inline: { type: Boolean, default: false },
    // 浅色系主色与高光色，支持复用场景自定义
    baseColor: { type: String, default: '#eee' },
    highlightColor: { type: String, default: 'rgba(255,255,255,0.6)' },
    duration: { type: [String, Number], default: 1.2 }
  },
  computed: {
    blockStyle() {
      const toPx = v => (typeof v === 'number' ? `${v}px` : v)
      const toSec = v => (typeof v === 'number' ? `${v}s` : v)
      return {
        width: toPx(this.width),
        height: toPx(this.height),
        borderRadius: toPx(this.radius),
        display: this.inline ? 'inline-block' : 'block',
        // 通过 CSS 变量将颜色传入伪元素动画中
        '--skeleton-base': this.baseColor,
        '--skeleton-highlight': this.highlightColor,
        '--skeleton-duration': toSec(this.duration),
        background: this.baseColor
      }
    }
  }
}
</script>

<style scoped>
.skeleton-block {
  position: relative;
  background: var(--skeleton-base, #eee);
  overflow: hidden;
}
.skeleton-block::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg,
    rgba(255,255,255,0) 0%,
    var(--skeleton-highlight, rgba(255,255,255,0.6)) 50%,
    rgba(255,255,255,0) 100%);
  transform: translateX(-100%);
  will-change: transform;
  animation: skeleton-shimmer var(--skeleton-duration, 1.2s) cubic-bezier(0.4, 0, 0.2, 1) infinite both;
}
@keyframes skeleton-shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
</style>